"use client";

import { useEffect } from "react";

import { FeedMainWrapper } from "@/components/app/feed/feed-main-wrapper/feed-main-wrapper";
import { useLayout } from "@/contexts/layout-context";
import { useUnreadNotificationsSignalState } from "@/contexts/user-context";

export const Home = () => {
  const { unreadNotifications } = useUnreadNotificationsSignalState();
  const { setDynamicTitle } = useLayout();

  useEffect(() => {
    return setDynamicTitle((originalTitle: string) => {
      if (unreadNotifications) {
        return `(${unreadNotifications}) ${originalTitle}`;
      }
      return originalTitle;
    });
  }, [setDynamicTitle, unreadNotifications]);

  return <FeedMainWrapper />;
};
